import { useTranslations } from 'next-intl'

import Button, { ButtonVariants } from '~/components/atoms/Button/Button'
import ReportCard from '~/components/blocks/ReportCard/ReportCard'

const SIGN_UP_IMAGE = {
  _ref: 'image-22ba986bc3de23dae0a919c3dc13029fc822c4e4-298x200-png',
  _type: 'reference' as const,
}

const SignUpCard = () => {
  const t = useTranslations('articleContainer')

  const titleNode = t.rich('signUpCardTitle', {
    em: chunks => <em>{chunks}</em>,
  })

  const footerContent = (
    <>
      {t('signUpCardFooterText')}{' '}
      <Button
        variant={ButtonVariants.textLinkLightSmallBold}
        launchAuthForm="login"
      >
        {t('signUpCardFooterCta')}
      </Button>
    </>
  )

  return (
    <ReportCard
      _id="sign-up-banner"
      titleNode={titleNode}
      title="Become a MyArtbroker Member for free"
      subtitle={t('signUpCardSubCopy')}
      leadImage={{ asset: SIGN_UP_IMAGE }}
      isPdfType={false}
      slug=""
      primaryCategory={{ name: '', slug: '' }}
      variant="featurePanel"
      matchGridHeight={false}
      ctaText={t('signUpCardCta')}
      ctaAuthForm="signup"
      ctaUrl=""
      footerContent={footerContent}
    />
  )
}

export default SignUpCard
